import { gql } from '@apollo/client';

export const DELETE_ORDER_CONFIRMATION_RECIPIENT = gql`
    mutation DeleteOrderConfirmationRecipient($id: String!) {
        deleteOrderConfirmationRecipient(id: $id) {
            name
        }
    }
`;
